export default function Configs(that) {
    const searchItems = [

        {
            label: "录取专业",
            span: 12,
            type: 'select',
            model: "classId",
            options: [],
            clearable: true,
        },
        {
            label: "拟调配专业",
            span: 12,
            type: 'select',
            model: "classId",
            options: [],
            clearable: true,
        },
    ]
    const tableColumnsAudit = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            minWidth: 180,
            show: true
        },
        // {
        //     label: "录取学院",
        //     prop: "originalCollegeName",
        //     align: "center",
        //     minWidth: 180,
        //     show: true
        // },
        {
            label: "录取专业",
            prop: "originalMajorName",
            align: "center",
            minWidth: 260,
            show: true
        },
     
        {
            label: "拟调配专业",
            prop: "applyMajorName",
            align: "center",
            minWidth: 260,
            show: true
        },
        // {
        //     label: "学院",
        //     prop: "collegeName",
        //     align: "center",
        //     show: true,
        //     minWidth: 180,
        // },
        // {
        //     label: "系别",
        //     prop: "departmentName",
        //     align: "center",
        //     show: true,
        //     minWidth: 180,
        // },
        // {
        //     label: "专业",
        //     prop: "majorName",
        //     align: "center",
        //     show: true,
        //     minWidth: 260,
        // },
        {
            label: "当前审批环节",
            prop: "taskName",
            align: "center",
            show: true,
            minWidth: 260,
        },
        // {
        //     label: "班级",
        //     prop: "className",
        //     align: "center",
        //     show: true,
        //     minWidth: 160,
        // },
        {
            label: "操作",
            name: 'contr',
            align: "center",
            show: true
        },
    ]
    const tableColumnsReviewed = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true,
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        // {
        //     label: "系别",
        //     prop: "departmentName",
        //     align: "center",
        //     show: true,
        //     minWidth: 180,
        // },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
            minWidth: 260,
        },
        // {
        //     label: "班级",
        //     prop: "className",
        //     align: "center",
        //     show: true,
        //     minWidth: 160,
        // },
        {
            label: "办理时间",
            prop: "handleTime",
            align: "center",
            show: true,
            minWidth: 260,
        },
        {
            label: "办理意见",
            prop: "fullMsg",
            align: "center",
            show: true,
            minWidth: 260,
        },
        {
            label: "操作",
            name: 'contr',
            align: "center",
            show: true
        },
    ]
    const tableColumnsHistory = [
        {
            label: "原专业",
            prop: "originalMajorName",
            align: "center",
            show: true,
        },
        {
            label: "申请专业",
            prop: "applyMajorName",
            align: "center",
            show: true,
        },
        {
            label: "审批状态",
            prop: "processStatusName",
            align: "center",
            show: true,
        },
        {
            label: "拒绝/取消原因",
            prop: "fullMsg",
            align: "center",
            show: true,
        },
        {
            label: "申请时间",
            prop: "createTime",
            align: "center",
            show: true,
        },
    ]
    return {
        searchItems,
        tableColumnsAudit,
        tableColumnsReviewed,
        tableColumnsHistory
    }
}